import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api } from '../api';
import { AuthContext } from '../App';

export default function LoginPage() {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPw, setShowPw] = useState(false);

  // 2FA state
  const [needs2fa, setNeeds2fa] = useState(false);
  const [pendingToken, setPendingToken] = useState('');
  const [tfaMethod, setTfaMethod] = useState('');
  const [tfaCode, setTfaCode] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await api.login(form);
      if (res.requires_2fa) {
        setNeeds2fa(true);
        setPendingToken(res.pending_token);
        setTfaMethod(res.method);
      } else {
        login(res.token, res.user);
        navigate('/');
      }
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  const handleVerify2fa = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await api.verify2faLogin({ pending_token: pendingToken, code: tfaCode });
      login(res.token, res.user);
      navigate('/');
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  if (needs2fa) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <h1>Verify Identity</h1>
          <p>Enter the 6-digit code sent to your {tfaMethod}</p>
          <form onSubmit={handleVerify2fa}>
            {error && <div className="error-msg">{error}</div>}
            <div className="form-group">
              <label>Verification Code</label>
              <input
                className="input"
                placeholder="123456"
                value={tfaCode}
                onChange={e => setTfaCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                maxLength={6}
                required
                autoFocus
                style={{ fontFamily: 'var(--font-pixel)', fontSize: '1.2rem', letterSpacing: '8px', textAlign: 'center' }}
              />
            </div>
            <button className="btn btn-primary" style={{ width: '100%', padding: '12px' }} disabled={loading || tfaCode.length !== 6}>
              {loading ? 'Verifying...' : 'Verify'}
            </button>
          </form>
          <div className="auth-switch" style={{ marginTop: '16px' }}>
            <button onClick={() => { setNeeds2fa(false); setTfaCode(''); setError(''); }}
              style={{ background: 'none', border: 'none', color: '#adadb8', cursor: 'pointer', fontSize: '0.85rem' }}>
              Back to login
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1>Welcome back</h1>
        <p>Log in to your Ninty account</p>
        <form onSubmit={handleSubmit}>
          {error && <div className="error-msg">{error}</div>}
          <div className="form-group">
            <label>Email or Username</label>
            <input className="input" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required />
          </div>
          <div className="form-group">
            <label>Password</label>
            <div style={{ position: 'relative' }}>
              <input className="input" type={showPw ? 'text' : 'password'} value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required style={{ paddingRight: '40px', marginBottom: 0 }} />
              <button type="button" onClick={() => setShowPw(!showPw)}
                style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', color: '#adadb8', cursor: 'pointer', fontSize: '0.8rem', fontFamily: 'var(--font-pixel)', padding: '4px' }}>
                {showPw ? 'o.o' : '-.-'}
              </button>
            </div>
          </div>
          <button className="btn btn-primary" style={{ width: '100%', padding: '12px' }} disabled={loading}>
            {loading ? 'Logging in...' : 'Log In'}
          </button>
        </form>
        <div className="auth-switch">
          Don't have an account? <Link to="/signup">Sign up</Link>
        </div>
      </div>
    </div>
  );
}
